export const editorLabels = {
    'components.controls.blocktype.code': 'Code Block',
}

// A more complete description for editor labels
// const editorLabels = {
//         // Generic
//     'generic.add': 'Add',
//     'generic.cancel': 'Cancel',
//         // BlockType
//     // 'components.controls.blocktype.h1': 'Heading 1',
//     // 'components.controls.blocktype.blockquote': 'Blockquote',
//     'components.controls.blocktype.code': 'Code Block',
//     // 'components.controls.blocktype.blocktype': 'Block Type',
//     'components.controls.blocktype.normal': 'Normal',
//         // Inline
//     'components.controls.inline.bold': 'Bold',
//     'components.controls.inline.italic': 'Italic',
//     'components.controls.inline.underline': 'Underline',
//     'components.controls.inline.strikethrough': 'Strikethrough',
//     'components.controls.inline.monospace': 'Monospace',
//     'components.controls.inline.superscript': 'Superscript',
//     'components.controls.inline.subscript': 'Subscript',
//         // List
//     'components.controls.list.list': 'List',
//     'components.controls.list.unordered': 'Unordered',
//     'components.controls.list.ordered': 'Ordered',
//         // Image
//     'components.controls.image.image': 'Image',
//     'components.controls.image.fileUpload': 'File Upload',
//     'components.controls.image.byURL': 'URL',
//     'components.controls.image.dropFileText': 'Drop the file or click to upload',
//   }